import * as React from "react";

import JackpotMoneyBox from "./JackpotMoneyBox";
import JackpotStars from "./JackpotStars";

import { IJackpotType } from "../../../interfaces/index";
import { JackpotTypeEnum } from "../../../enums";

const JackpotInfoBox: React.FC<IJackpotType> = ({ type }) => (
  <div className={`info_box small ${type}`}>
    <div className={`jackpot ${type}`}>
      <JackpotStars type={type} />
      <div className="title">
        {type === JackpotTypeEnum.GOLD ? "GOLD JACKPOT" : "Silver jackpot"}
      </div>
    </div>
    <JackpotMoneyBox currency="$" amount="555.555,5" />
  </div>
);

export default JackpotInfoBox;
